module.exports = __webpack_public_path__ + "franchise-ac-desktop.png";